import { PID_SET } from '../shared/action-names';
import { pidActionTypes } from './types';

export function pidSet(pid: string): pidActionTypes {
  return { type: PID_SET, payload: pid };
}
